import { getLocalizedName } from "../getLocalizedMetaData"
import { formatProductVariant } from "./formatProduct"

import { RawProduct } from "../graphql/queries/fetchProduct"
import { ProductTypeName } from "@secureo/common/typings/Product"
import { LockingSystemProduct } from "@secureo/common/typings/LockingSystem"

const formatLockingSystemProduct = (lockingSystemProduct: RawProduct, locale: string) => {
	const {
		id,
		masterData: {
			current: { slug, masterVariant, variants },
		},
	} = lockingSystemProduct

	const sku = masterVariant.sku
	const productType = lockingSystemProduct?.productType?.name as ProductTypeName

	const formattedProductVariants = [masterVariant, ...variants].map((variant) =>
		formatProductVariant(masterVariant.sku, variant, productType),
	)
	const [formattedMasterVariant] = formattedProductVariants

	// TODO: Use lockingSystemComponentName?
	const name = getLocalizedName(lockingSystemProduct.masterData.current, locale)

	const shortDescription = formattedMasterVariant?.attributes?.shortDescription ?? null
	// Prevent duplicated data in response
	delete formattedProductVariants[0]?.attributes?.shortDescription

	const formattedLockingSystemProduct: LockingSystemProduct = {
		productType,
		id,
		sku,
		slug,
		name,
		shortDescription,
		variants: formattedProductVariants,
	}

	return formattedLockingSystemProduct
}

export default formatLockingSystemProduct
